import React from 'react';
import './EmptyState.css';

/**
 * Componente empty state reutilizable
 * 
 * @param {string} icon - Emoji o icono simple (opcional)
 * @param {string} title - Título principal
 * @param {string} message - Mensaje descriptivo (opcional)
 * @param {React.ReactNode} action - Botón o acción CTA (opcional)
 * @param {string} size - Tamaño: 'small', 'medium', 'large' (default: 'medium')
 */
function EmptyState({ 
  icon = '📭', 
  title = 'No hay datos', 
  message, 
  action, 
  size = 'medium' 
}) {
  return (
    <div className={`empty-state empty-state--${size}`}>
      <div className="empty-state-icon">{icon}</div>
      <h3 className="empty-state-title">{title}</h3>
      {message && <p className="empty-state-message">{message}</p>}
      {action && <div className="empty-state-action">{action}</div>}
    </div>
  );
}

export default EmptyState;
